import { SurveyCompletionStatus } from 'constants/surveyCompletionStatus';

// Check if the message was that the survey was submitted.
export const isMessageCompletionStatus = (
  message: string
): message is SurveyCompletionStatus =>
  Object.values(SurveyCompletionStatus).includes(
    message as SurveyCompletionStatus
  );
